import React from 'react'
import GoogleMapReact from 'google-map-react'

const defaultProps = {
  center: {
    lat: 41.26834379789116,
    lng: -72.96126514097387,
  },
  zoom: 11,
}

const AnyReactComponent = ({ text, tagStyle }) => <div className={tagStyle}>
  <svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 15.8125C16.0607 15.8125 15.1599 15.4503 14.4957 14.8057C13.8315 14.161 13.4584 13.2867 13.4584 12.375C13.4584 11.4633 13.8315 10.589 14.4957 9.94432C15.1599 9.29966 16.0607 8.9375 17 8.9375C17.9394 8.9375 18.8402 9.29966 19.5044 9.94432C20.1686 10.589 20.5417 11.4633 20.5417 12.375C20.5417 12.8264 20.4501 13.2734 20.2721 13.6905C20.0941 14.1075 19.8333 14.4865 19.5044 14.8057C19.1755 15.1249 18.7851 15.3781 18.3554 15.5508C17.9257 15.7236 17.4651 15.8125 17 15.8125V15.8125ZM17 2.75C14.37 2.75 11.8476 3.76406 9.9879 5.5691C8.12816 7.37413 7.08337 9.82229 7.08337 12.375C7.08337 19.5938 17 30.25 17 30.25C17 30.25 26.9167 19.5938 26.9167 12.375C26.9167 9.82229 25.8719 7.37413 24.0122 5.5691C22.1524 3.76406 19.6301 2.75 17 2.75V2.75Z" fill="#CA3333"/>
  </svg>
  {text}
</div>

const GoogleMap = ({style, tagStyle}) => (
  <div className={style}>
    <GoogleMapReact
      bootstrapURLKeys={{ key: 'AIzaSyBXVx-zla5k-toUGpSkZWjsquEwxlOt6k8' }}
      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}
    >
      <AnyReactComponent
        lat={41.286090}
        lng={-72.974130}
        text={'Slate Pages'}
        tagStyle={tagStyle}
      />
    </GoogleMapReact>
  </div>
)

export default GoogleMap